import { useTranslation } from "react-i18next";
import { Form, Formik } from "formik";
import * as Yup from "yup";
import { toast } from "react-hot-toast";
import { FormikSaveBar } from "../../../utils/FormikSaveBar";
import { PMField } from "../../../utils/PMField";
import { useDispatch } from "react-redux";
import PMSwitch from "../../../utils/PMSwitch";
import { useNavigate } from "react-router-dom";
import {
  createProjectCategoryAsync,
  updateProjectCategoryAsync,
} from "../../../../slices/projectCategories";

export const ProjectCategoryForm = (props) => {
  const { t } = useTranslation();
  const { item, onRefresh } = props;
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const isEdit = !!item?.id;

  return (
    <>
      <Formik
        initialValues={{
          id: item?.id,
          name: item?.name || "",
          description: item?.description || "",
          is_active: item?.is_active !== undefined ? item.is_active : true,
        }}
        validationSchema={Yup.object({
          name: Yup.string().max(255).required(t("Name is required")),
          description: Yup.string().max(1000),
        })}
        onSubmit={(values, helpers) => {
          try {
            const action = isEdit
              ? dispatch(updateProjectCategoryAsync(values))
              : dispatch(createProjectCategoryAsync(values));

            action
              .then((result) => {
                if (result.payload) {
                  toast.success(
                    isEdit
                      ? "Project category updated successfully"
                      : "Project category created successfully"
                  );
                  if (onRefresh) {
                    onRefresh(result.payload);
                  } else {
                    navigate("/dashboard/projects/settings/categories");
                  }
                } else {
                  toast.error("Failed to save project category");
                }
                helpers.setSubmitting(false);
              })
              .catch((error) => {
                toast.error("Error saving project category");
                helpers.setSubmitting(false);
              });
          } catch (err) {
            toast.error("Nope");
            console.error(err);
            helpers.setStatus({ success: false });
            helpers.setErrors({ submit: err.message });
            helpers.setSubmitting(false);
          }
        }}
      >
        {(formik) => (
          <Form>
            <div className="shadow sm:overflow-hidden sm:rounded-md">
              <div className="space-y-6 bg-white py-6 px-4 sm:p-6">
                <div>
                  <h3 className="text-lg font-medium leading-6 text-gray-900">
                    {isEdit ? "Edit Project Category" : "New Project Category"}
                  </h3>
                  <p className="mt-1 text-sm text-gray-500">
                    {isEdit
                      ? "Update the project category details below."
                      : "Create a new project category by filling out the form below."}
                  </p>
                </div>

                <div className="grid grid-cols-6 gap-6">
                  <div className="col-span-6 sm:col-span-4">
                    <PMField
                      name="name"
                      type="text"
                      label={t("Name")}
                      {...formik}
                    />
                  </div>

                  <div className="col-span-6 sm:col-span-2">
                    <PMSwitch label="Active" name="is_active" {...formik} />
                  </div>

                  <div className="col-span-6">
                    <PMField
                      name="description"
                      type="text"
                      label={t("Description")}
                      multiline
                      rows={4}
                      {...formik}
                    />
                  </div>
                </div>
              </div>
            </div>

            <FormikSaveBar {...formik} />
          </Form>
        )}
      </Formik>
    </>
  );
};
